import React, { useContext } from 'react'

import {  
    Box,
    Grid,
    LinearProgress,
    IconButton,
    Stack,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { CaricoMerceContext } from '../contexts';
import { Edit } from "@mui/icons-material";


function CustomFooterStatusComponent() {
    return <></>;
  }

const ViaggiTable = ({columnsData, rowsData, navigate, detailFunc, TipoDati}) => {
    const {
        resetRicercaData,
    } = useContext(CaricoMerceContext)
    const [customCol, setCustomCol] = React.useState([]);
    
    const onVisualizza = (prgInterno, navigate) => {
        resetRicercaData();
        detailFunc(prgInterno, navigate)
    }

    React.useEffect(() => {
        let colonneDaModificare=[];
        if (columnsData){
          columnsData.map((res, i) => {
            if (res.id === 'StatoDiCarico' ){
              colonneDaModificare = [
                ...colonneDaModificare,
                {
                  field: res.id,
                  headerName: res.label,
                  width: res.minWidth,
                  sortable: false
                },
              ];
            }
            else {
              colonneDaModificare = [
                ...colonneDaModificare,
                {
                  field: res.id,
                  headerName: res.label,
                  width: res.minWidth < 140? (140):(res.minWidth),
                  sortable: false
                },
              ];
            }
          });          
        }
        colonneDaModificare = [
           {
             field: "",
             headerName: "Azioni",
             sortable: false,
             //12/06/2024 Greg: impostata width altrimenti dimensione di default esagerata
             width:65,
             renderCell: (params) => (
               <Stack direction={"row"} spacing={2}>
                   <IconButton
                     color="info"
                     aria-label="upload picture"
                     component="span"
                     size="small"
                     onClick={() => onVisualizza(
                      TipoDati === 'DIS'?(params.row.PrgDistinta):(params.row.PrgViaggio)
                      , navigate)
                    }
                   >
                     <Edit />
                   </IconButton>
               </Stack>
             ),
           },
           ...colonneDaModificare,
          
         ];
        setCustomCol(colonneDaModificare);
      }, [columnsData]);



      const handleRowClick = (params) => {
        resetRicercaData();
        detailFunc(
          TipoDati === 'DIS'?(params.row.PrgDistinta):(params.row.PrgViaggio),
          navigate
        )
      };

  return (
    <Grid container spacing={2}>
        <Grid item xs={12} md={12} lg={12}>
        {columnsData && customCol.length > 0 && columnsData.length > 0 ? (
            <Box sx={{ width: '100%' }}>
            {/*  <TableRowHtml rows={caricoMerce}
                customCol={customCol}></TableRowHtml> */}
            <DataGrid 
                onRowClick={handleRowClick}
                rows={rowsData}
                columns={customCol}
                getRowId={(row) => TipoDati === 'DIS'?(row.PrgDistinta):(row.PrgViaggio)}
                disableSelectionOnClick
                disableColumnFilter
                disableVirtualization
                disableColumnSelector
                disableExtendRowFullWidth
                disableDensitySelector
                disableColumnMenu
                autoHeight
                components={{
                Footer: CustomFooterStatusComponent,
                }}
                sx={{ margin: 1 }}
            />
            </Box>
        ) : (
            <LinearProgress p={2} />
        )}
        </Grid>
    </Grid>
  )
}

export default ViaggiTable